var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpot = function SvgSpot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.188 14.062a7.75 7.75 0 1 1 15.5 0 7.75 7.75 0 0 1-15.5 0m7.75-6.25a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.686 13.388v-1.24l.93.364c.094.027.175.054.27.054a.77.77 0 0 0 .619-.323.73.73 0 0 0-.054-.916c-.404-.472-1.037-.809-1.765-.944v-.067a.753.753 0 1 0-1.509 0v.081c-1.307.242-2.25 1.105-2.25 2.17 0 1.063.943 1.926 2.25 2.168v1.24l-.93-.364a.74.74 0 0 0-.875.27.73.73 0 0 0 .054.916c.404.471 1.037.808 1.765.943v.067a.753.753 0 1 0 1.509 0v-.08c1.307-.243 2.25-1.105 2.25-2.17-.014-1.064-.957-1.927-2.264-2.169m-1.495-.202c-.472-.148-.755-.418-.755-.633s.283-.485.755-.634zm1.495 3.004v-1.266c.472.148.755.418.755.633 0 .202-.283.485-.755.633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.074 4.856a7.75 7.75 0 1 1 11.224 10.652.75.75 0 1 1-1.026-1.094 6.25 6.25 0 1 0-9.052-8.59.75.75 0 1 1-1.146-.968",
    clipRule: "evenodd"
  })));
};
export default SvgSpot;